import React, { useEffect, useState } from 'react'
import TableWrapper from '../../../../component/TableWrapper';
import { Icons } from '../../../../assets';
import { useNavigate } from 'react-router-dom';
import request from '../../../../service';
import Exported from '../../../../service/endpoints';
import { useDispatch } from 'react-redux';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { Toast } from '../../../../service/toast';
import moment from 'moment';

const RedeemList = ({ handlePageChange, searchInput, handleStatus,checked, currentTab, ids, setIds }) => {

    const COMPLETED = 'Completed'
    const NEW_ENQUIRY = 'New'
    const IN_PROGRESS = 'In Progress'
    const dispatch = useDispatch();
    const activeTab = currentTab
    const [page, setPage] = useState(1);
    const [redeemTableList, setRedeemTableList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState(null);
    const check = checked
    const statusValue = activeTab === "Order Placed" ? 1 : activeTab === "Order Delivered" ? 3 : activeTab === "Order Cancelled" ? 4 : activeTab === "Order Rejected" ? 5 : null

    
    const navigate = useNavigate()

    const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        if (redeemTableList?.result) {
            console.log(ids)
            if (selectAll) {
                setIds(redeemTableList?.result?.map(item => item.id));
            } else {
                setIds([]);
            }
        }
    }, [selectAll, redeemTableList?.result]);

    const handleSelectAll = () => {
        setSelectAll(!selectAll);
    };

    const userHeader = [
        ...(activeTab === "Order Placed" ? [{
            label: (
                <div className="flex items-right justify-right ml-9">
                    <input
                        type="checkbox"
                        className=""
                        checked={selectAll}
                        onChange={handleSelectAll}
                    />
                </div>), sortable: ''
        }] : []),
        { label: "Redeemer's ID", sortable: 'enquiry_id' },
        { label: 'Customer Name', sortable: 'username' },
        { label: 'Redeem Date', sortable: 'enquiry_date' },
        { label: 'Actions' }
    ];

    const getReedemList = async (loading) => {
        setisLoading(loading)

        let url = `${Exported.Endpoints.getRedeemRewardsList}`
        let paramsObj = {
            page: page,
            limit: 10,
        }
        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }
        if (sortConfig) {
            paramsObj['sort'] = sortConfig?.key
            paramsObj['sortOrder'] = sortConfig?.direction
        }
        if(statusValue){
            paramsObj['status'] = statusValue
        }

        await request({
            url: url,
            method : Exported.APIMethods.GET,
            params: { ...paramsObj }
        }).then((res) => {
            console.log(res)
            if (res?.data?.status) {
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta,
                }
                setRedeemTableList(obj)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        setisLoading(false)



    }

    useEffect(() => {
        getReedemList(true)
    }, [searchInput, sortConfig, page, check, activeTab])


    const handleData = (keyValue, defaultValue, className = '') => {
        return (
            <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
        )
    };

    const redirectTo = (id) => {
        navigate(`?id=${id}`)
    }

    const handleCheckboxChange = (id) => {
        console.log(ids)
        if (ids.includes(id)) {
            setIds(ids.filter((selectedId) => selectedId !== id));
        } else {
            setIds([...ids, id]);
        }
    };
    
    return (
        <>
            <div className={`eventWrapper`}>
                <div className={`mt-2 mb-5`}>
                    <TableWrapper
                        headerDetails={userHeader}
                        pageMeta={redeemTableList?.pageMeta}
                        handlePageChange={setPage}
                        listLength={redeemTableList?.result || []}
                        isLoading={isLoading}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                    >
                        {redeemTableList?.result?.map((item, index) => {
                            const { user_id = '', user_details = '', product = '', redeemed_on = '', status = '', id='' } = item;
                            const dateConvert = new Date(redeemed_on);
                            const monthName = dateConvert.toLocaleString('en-US', { month: 'long' });
                            let date = `${dateConvert.getDate()} ${monthName} ${dateConvert.getFullYear()}`;

                            return (
                                <tr key={id}>
                                    {activeTab === "Order Placed" && (
                                        <td className=" px-3 mx-auto text-center">
                                            <div className="flex items-right justify-right ml-9">
                                                <input
                                                    type="checkbox"
                                                    className=""
                                                    checked={ids.includes(id)}
                                                    onChange={() => handleCheckboxChange(id)}
                                                />
                                            </div>
                                        </td>
                                    )}
                                    {handleData(id, "-", "text-center")}
                                    {handleData(
                                        `${user_details?.firstName} ${user_details?.lastName}`,
                                        "-",
                                        "text-center"
                                    )}
                                    {/* {handleData(product?.category?.title, '-', 'text-center')} */}
                                    {handleData(date, "-", "text-center")}
                                    {/* <td className=" px-3 mx-auto text-center">
                                        <div className='' style={{
                                            color: status === 3 ? '#01CB46' :
                                                status === 1 ? '#FC0000' : status === 2 ? '#D99E27' : '#000000'
                                        }}>
                                            {status === 3 ? 'Completed' :
                                                status === 1 ? 'New' : status === 2 ? 'In Progress' : ""}
                                        </div>
                                    </td> */}
                                    <td className=" px-3 mx-auto text-center action-button">
                                        <div className="flex items-center justify-center">
                                            {/* <img src={Icons.edit} alt='Edit' className='cursor-pointer w-[16px] h-[16px]' /> */}
                                            <img
                                                src={Icons.eye}
                                                alt="View"
                                                className="cursor-pointer w-[20px] h-[20px]"
                                                onClick={() => redirectTo(id)}
                                            />
                                            {activeTab === "Order Placed" && (
                                                <img
                                                    src={Icons.checked}
                                                    alt="Done"
                                                    className="cursor-pointer w-[22px] h-[22px] mx-2"
                                                    style={{
                                                        opacity: (status == "3" || ids.length > 1) ? "0.5" : "1",
                                                        pointerEvents:
                                                        (status == "3" || ids.length > 1) ? "none" : "auto",
                                                    }}
                                                    onClick={() =>
                                                        (status == "3" || ids.length > 1)
                                                            ? null
                                                            : handleStatus(id)
                                                    }
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </TableWrapper>
                </div>
            </div>
        </>
    )
}

export default RedeemList